import SocialApp from './vue/SocialApp.vue';

if( document.querySelector('#social-app')) {
    new Vue({
        el: "#social-app",
        name: 'Social',
        render: h => h(SocialApp),
    })
}


// WEBPACK FOOTER //
// ./scripts/home.js